/**
 * Konfiguracja środowiska – wariant domyślny (`ng build`, czyli `stage`/prod).
 * W konfiguracji `development` plik jest podmieniany na
 * `environment.development.ts` (`fileReplacements` w `angular.json`).
 */
export const environment = {
  production: true,
  /** Ładowanie Google Tag Managera w kreatorze. */
  gtmEnabled: true,
};
